import { useEffect, useRef } from 'react';
import { redeemCampaign } from 'src/services/campaign.service';
import {
  getCampaignFromSession,
  clearCampaignFromSession,
} from 'src/util/campaign.util';

/**
 * Hook that redeems a campaign code on the success page.
 *
 * Reads the campaign code from sessionStorage (persisted earlier by useCampaign).
 * If present, fires a one-time POST to the campaign redeem API, then clears
 * the sessionStorage entry. Fails silently — campaign redemption should never
 * break the success page.
 */
export const useCampaignRedemption = (priceId: string): void => {
  const hasRedeemedRef = useRef(false);

  useEffect(() => {
    if (hasRedeemedRef.current) {
      return;
    }

    const campaignCode = getCampaignFromSession();

    if (!campaignCode) {
      return;
    }

    hasRedeemedRef.current = true;

    const redeem = async () => {
      try {
        await redeemCampaign({ promoCode: campaignCode, priceId });
        clearCampaignFromSession();
      } catch (error) {
        console.error(
          '[useCampaignRedemption] Campaign redemption failed:',
          error
        );
        clearCampaignFromSession();
      }
    };

    redeem();
  }, [priceId]);
};
